/**
 * @generated SignedSource<<366437708edcda90dbba6bf6b9d71e0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanyContainerQuery$variables = {
  companyId: string;
};
export type CompanyContainerQuery$data = {
  readonly companyById: {
    readonly id: string;
    readonly rowId: any;
    readonly name: string;
    readonly legalName: string | null;
  } | null;
};
export type CompanyContainerQuery = {
  variables: CompanyContainerQuery$variables;
  response: CompanyContainerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "companyId"
      }
    ],
    "concreteType": "Company",
    "kind": "LinkedField",
    "name": "companyById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "legalName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyContainerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "171528d9f01aa47ba6f3bb7ca767bc58",
    "id": null,
    "metadata": {},
    "name": "CompanyContainerQuery",
    "operationKind": "query",
    "text": "query CompanyContainerQuery(\n  $companyId: ID!\n) {\n  companyById(id: $companyId) {\n    id\n    rowId\n    name\n    legalName\n  }\n}\n"
  }
};
})();

(node as any).hash = "600d564ba3c38fe8d75cb8b6e6c4e7c3";

export default node;
